import { useEffect, useState } from "react";
import { listAll, type OutboxMutation, subscribeOutbox } from "@/lib/outbox";

/**
 * useOutboxMutations mantiene la lista completa de mutaciones de la outbox (en orden FIFO), viva
 * ante cada cambio (encolar/aplicar/reintentar/descartar) vía el pub/sub de la outbox. Es la
 * fuente del centro de conflictos (#53), que la parte en «pendientes de enviar» y «requieren
 * atención» (conflict/rejected/blocked).
 */
export function useOutboxMutations(): { mutaciones: OutboxMutation[]; cargando: boolean } {
  const [mutaciones, setMutaciones] = useState<OutboxMutation[]>([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let active = true;
    const refresh = (): void => {
      void listAll().then((rows) => {
        if (active) {
          setMutaciones(rows);
          setCargando(false);
        }
      });
    };
    refresh();
    const unsubscribe = subscribeOutbox(refresh);
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return { mutaciones, cargando };
}
